module.exports = __webpack_public_path__ + "static/media/digitales-01.801d8dd1.png";